export const routes = {
  LOGIN: '/login',
  REGISTER: '/register',
  SEARCH: '/search',
  HOMEPAGE: '/home',
  CATEGORY: '/category',
  MOVIES: '/movie',
  SERIES: '/serie',
  MY_LIST: '/my-list',
  INITIAL_PAGE: '/initial-page',
  HOME: '/home',
  MANAGE_PROFILES: '/manage-profiles',
  PLAYER: '/player',
  SETTINGS: '/settings',
}

export const loginRoutes = {
  FORGOT_PASSWORD: 'forgot-password',
  PIN_AND_PAIR: 'pin-and-pair',
  ACCOUNT_ERROR: 'account-error',
}

export const settingsRoutes = {
  LEGAL: 'legal',
  LOGOUT: 'logout',
}

export const profileRoutes = {
  EDIT_PROFILE: 'edit-profile',
  PROFILE_INFO: 'profile-info',
  EDIT_LANG: 'edit-language',
  EDIT_NAME: 'edit-name',
  CREATE_NEW_PROFILE: 'create-new-profile',
  DELETE_PROFILE: 'delete-profile',
  PASSWORD_CONFIRMATION: 'password-confirmation',
  CONTENT_CLASSIFICATION: 'content-classification',
  PIN_SETUP: 'pin-setup',
  CHOOSE_ICON: 'choose-icon',
}
export const editProfileRoute = `${routes.MANAGE_PROFILES}/${profileRoutes.EDIT_PROFILE}`

export const getEditProfileIdRoute = (profileId?: string) => `${editProfileRoute}/${profileId}`

export const getEditLangProfileIdRoute = (profileId?: string) =>
  `${editProfileRoute}/${profileId}/${profileRoutes.EDIT_LANG}`

export const getEditNameProfileIdRoute = (profileId?: string) =>
  `${editProfileRoute}/${profileId}/${profileRoutes.EDIT_NAME}`

export const getEditProfileIdPasswordRoute = (profileId?: string) =>
  `${editProfileRoute}/${profileId}/${profileRoutes.PASSWORD_CONFIRMATION}`

export const getEditProfileIdContentClassRoute = (profileId?: string) =>
  `${editProfileRoute}/${profileId}/${profileRoutes.CONTENT_CLASSIFICATION}`

export const getEditProfileIdPinRoute = (profileId?: string) =>
  `${editProfileRoute}/${profileId}/${profileRoutes.PIN_SETUP}`

export const getDeleteProfileIdRoute = (profileId?: string) =>
  `${editProfileRoute}/${profileId}/${profileRoutes.DELETE_PROFILE}`

export const getEditChooseIconRoute = (profileId?: string) =>
  `${editProfileRoute}/${profileId}/${profileRoutes.CHOOSE_ICON}`

export const focusableRoutes = {
  CATEGORY: 'category',
  PROFILE: 'profile',
  MENU: 'menu',
}

export const mainRoutes = {
  HOME: 'home',
  MOVIE: 'movie',
  SERIES: 'serie',
}

export const routeData = {
  CATEGORY: 'category-page',
}

export const assetType = {
  MOVIE: 'movie',
  SERIE: 'serie',
}
